module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO7_21 (28).92212e4.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO7_21 (28).mp4
// module id = 803
// module chunks = 1